import { useTranslation } from 'react-i18next';
import { BookOpen, ChevronRight } from 'lucide-react';
import { TranslatedCalling } from './common';

function KnowledgebaseResult({
  toolCall,
  expanded,
  setExpanded,
}: {
  toolCall: any;
  expanded: boolean;
  setExpanded: (fn: (v: boolean) => boolean) => void;
}) {
  const { t } = useTranslation('chat');
  const result = toolCall.result || {};
  const formatted = result.formatted || [];
  const query = toolCall.args?.query || '';
  const hasResults = Array.isArray(formatted) && formatted.length > 0;

  return (
    <div className="my-4">
      <div className="flex items-center cursor-pointer select-none" onClick={() => setExpanded((v: boolean) => !v)}>
        <div className="text-xs text-gray-400 font-light flex items-center gap-1">
          <BookOpen className="w-3 h-3" />
          {t('tool.query-marketing-knowledgebase.searched')}
        </div>
        <ChevronRight
          className={`ml-2 w-3 h-3 text-gray-400 transition-transform duration-200 ${expanded ? 'rotate-90' : 'rotate-0'}`}
        />
      </div>
      {expanded && (
        <div className="mt-3 ml-4">
          <div className="text-xs text-gray-600 mb-3">"{query}"</div>
          {hasResults ? (
            <div className="flex flex-wrap gap-2">
              {formatted.map((item: any, index: number) => (
                <div
                  key={index}
                  className="bg-gray-50 text-gray-700 text-xs px-3 py-1.5 rounded-full border border-gray-200"
                >
                  {item.content}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-gray-500 text-xs">{t('tool.query-marketing-knowledgebase.no-results')}</div>
          )}
        </div>
      )}
    </div>
  );
}

export const query_marketing_knowledgebase = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.query-marketing-knowledgebase.searching" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.query-marketing-knowledgebase.searching-short" />,
  result: ({ toolCall, expanded, setExpanded }: any) => (
    <KnowledgebaseResult toolCall={toolCall} expanded={expanded} setExpanded={setExpanded} />
  ),
};
